module.exports = __webpack_public_path__ + "img/logo.36214b47.png";